import Cookies from "js-cookie";
import { userDBService } from "./dbInstances";

export function isFormComplete(form, ignoredFields = []) {
  if (!form) {
    return false;
  }

  return Object.entries(form).every(([key, value]) => {
    if (ignoredFields.includes(key)) {
      return true;
    }
    
    return value !== null && value !== undefined && value !== "";
  });
}
  
export function getExtension(filename = "") {
  if (filename.includes(".")) {
    return filename.split(".").pop();
  } else {
    return "";
  }
}

export const sortNumbers = (val1, val2) => val1 - val2;
export const sortStrings = (val1 = "", val2 = "") => val1.toLowerCase().localeCompare(val2.toLowerCase());
export const sortDates = (val1, val2) => new Date(val1) - new Date(val2);

export const invalidateSession = async() => {
  const cookiesToRemove = [
    "pnAccessToken",
    "pnCmPk",
    "userType",
    "category",
    "token_exp",
  ];

  cookiesToRemove.forEach((cookie) => Cookies.remove(cookie, { path: "/" }));
  await userDBService.clear()

  window.location.href = "/";
};

export default null;